"use client"
/* */
import { jsx, jsxs } from 'react/jsx-runtime';
import { useContext } from 'react';
import * as Aria from 'react-aria-components';
import { ClearPropsContext } from '../ClearPropsContext/ClearPropsContext.mjs';
import '../../lib/propsContext/propsContext.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import styles from './Link.module.scss.mjs';
import clsx from 'clsx';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import { linkContext } from './context.mjs';
import { LinkIcon } from './components/LinkIcon/LinkIcon.mjs';

const Link = flowComponent("Link", (props) => {
  const {
    children,
    className,
    inline,
    linkComponent: linkComponentFromProps,
    color = "primary",
    unstyled = false,
    "aria-current": ariaCurrent,
    ref,
    slot: ignoredSlotProp,
    ...rest
  } = props;
  const { linkComponent: linkComponentFromContext } = useContext(linkContext);
  const Link2 = linkComponentFromProps ? linkComponentFromProps : props.href && linkComponentFromContext ? linkComponentFromContext : Aria.Link;
  const rootClassName = unstyled ? className : clsx(
    styles.link,
    inline && styles.inline,
    styles[color],
    className
  );
  const propsContext = {
    Icon: {
      className: styles.icon,
      size: "s"
    }
  };
  const unsupportedTypingsLinkProps = ariaCurrent ? {
    "aria-current": true
  } : {};
  return /* @__PURE__ */ jsx(ClearPropsContext, { children: /* @__PURE__ */ jsx(
    Link2,
    {
      ...unsupportedTypingsLinkProps,
      ...rest,
      className: rootClassName,
      ref,
      children: /* @__PURE__ */ jsxs(PropsContextProvider, { props: propsContext, children: [
        children,
        /* @__PURE__ */ jsx(LinkIcon, { ...props })
      ] })
    }
  ) });
});

export { Link, Link as default };
//# sourceMappingURL=Link.mjs.map
